import data from './data/climate-ratios-2026.json';
import { CLIMATE_PERIODS, cloneRatios, mapRatioTable } from './domain';
import type { DegreeDays, RatioTable, UsageKey } from './types';

export const CLIMATE_ZONES = data.zones.map(zone => zone.zone);
const usageKeys = [
  'resCollectif', 'resIndividuel', 'tertiaire', 'hotel', 'sante', 'enseignementPrimaire',
  'enseignementSuperieur', 'loisirs', 'industrie', 'commercial', 'piscine',
] as const satisfies readonly UsageKey[];

/** Chargement explicite : aucune zone n'est inférée de la commune ou de la station simulée. */
export function climateRatios(zone: string): { degrees: DegreeDays; ratios: RatioTable } {
  const source = data.zones.find(entry => entry.zone === zone);
  if (!source) throw new Error(`Zone climatique inconnue : ${zone}`);
  const ratios: RatioTable = {
    ...mapRatioTable((u, p) => {
      const i = usageKeys.findIndex(key => key === u);
      const period = CLIMATE_PERIODS.findIndex(period => period.key === p);
      if (i < 0 || period < 0) return { chauffage: null, ecs: null, froid: null };
      const row = source.rows[i];
      return {
        chauffage: row.reference.chauffage * row.factors[period],
        ecs: row.reference.ecs * row.factors[period],
        froid: row.reference.froid * row.factors[period],
      };
    }),
    periodSchema: 'climate2026', climateZone: zone,
  };
  ratios.performance = mapRatioTable((u, p) => {
    const i = usageKeys.findIndex(key => key === u);
    const period = CLIMATE_PERIODS.findIndex(period => period.key === p);
    const factor = i < 0 || period < 0 ? null : source.rows[i].factors[period] * 100;
    return { chauffage: factor, ecs: factor, froid: factor };
  });
  return { degrees: { dju: source.dju, djclim: source.djclim }, ratios: cloneRatios(ratios) };
}
